import CryptoJS from 'crypto-js';

export default class Key {
  constructor() {
    this.secret_key = process.env.MIX_APP_PUBLIC_KEY;
    this.salt = process.env.MIX_APP_PUBLIC_SALT;
  }

  getString () {
    return Math.floor(Date.now() / 1000).toString();
  }

  get() {
    const Sha256 = CryptoJS.SHA256;
    const AES = CryptoJS.AES;

    const {Hex, Utf8, Base64} = CryptoJS.enc;

    const key = Sha256(this.secret_key).toString(Hex).substr(0,32);
    const iv = Sha256(this.salt).toString(Hex).substr(0,16);

    const output = AES.encrypt(this.getString(), Utf8.parse(key), { iv: Utf8.parse(iv) }).toString();

    return Utf8.parse(output).toString(Base64);
  }
}

window.Key = new Key;